import { Download, Phone } from "lucide-react";
import { QRCodeSVG } from "qrcode.react"

import { useCurrentBranch } from "@/context/current-branch-provider";
import { Reservation } from "@/types/popadvise";
import { SYSTEM_BE } from "@/lib/constants";
import { toast } from "@/hooks/use-toast";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function ReservationResult({ reservation }: {
    reservation: Reservation | null
}) {
    const { currentBranch } = useCurrentBranch()
    // const [loading, setLoading] = useState(false)

    function formatDate(fechaString) {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        const [year, month, day] = fechaString.split("-");

        return `${parseInt(day)} de ${meses[parseInt(month) - 1]} ${year}`;
    }

    const download = () => {
        // setLoading(true)

        const formData = new FormData()

        fetch(SYSTEM_BE + "/v1/reservations/download-pdf?encrypted=" + reservation?.encrypted, {
            method: 'POST',
            body: formData
        })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Reserva.pdf')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
            .catch(() => {
                toast({
                    title: "No se pudo descargar la reservación.",
                    description: "Intentar más tarde.",
                    variant: "destructive"
                })
            })
            .finally(() => {
                // setLoading(false)
            })
    }

    return (
        <>
            <div className="p-6">
                <CardHeader className="px-0">
                    <svg className="mx-auto mb-4" width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28.4993 4.66675C15.6427 4.66675 5.16602 15.1434 5.16602 28.0001C5.16602 40.8567 15.6427 51.3334 28.4993 51.3334C41.356 51.3334 51.8327 40.8567 51.8327 28.0001C51.8327 15.1434 41.356 4.66675 28.4993 4.66675ZM39.6527 22.6334L26.4227 35.8634C26.096 36.1901 25.6527 36.3767 25.186 36.3767C24.7193 36.3767 24.276 36.1901 23.9493 35.8634L17.346 29.2601C16.6693 28.5834 16.6693 27.4634 17.346 26.7867C18.0227 26.1101 19.1427 26.1101 19.8193 26.7867L25.186 32.1534L37.1793 20.1601C37.856 19.4834 38.976 19.4834 39.6527 20.1601C40.3293 20.8367 40.3293 21.9334 39.6527 22.6334Z" fill="#00EDAE" />
                    </svg>
                    <CardTitle className="text-center text-xl">Reserva confirmada</CardTitle>
                    <CardDescription className="text-center text-[#6C6C6C]">
                        Esta es la informacion con la que se agendo tu reserva
                    </CardDescription>
                </CardHeader>
                <main>
                    <QRCodeSVG className="mb-5 mx-auto" value={reservation.uuid} />
                    <h2 className="text-center text-lg font-medium mb-8">{currentBranch.name}</h2>
                    <section className="grid grid-cols-2 md:grid-cols-2 gap-3 mb-8">
                        <article className="p-3 rounded-lg border flex flex-col gap-1 justify-center items-center">
                            <h3 className="font-semibold">Dia</h3>
                            <p className="text-sm text-center line-clamp-1">{formatDate(reservation.date)}</p>
                        </article>
                        <article className="p-3 rounded-lg border flex flex-col gap-1 justify-center items-center">
                            <h3 className="font-semibold">Hora</h3>
                            <p className="text-sm text-center">{reservation.time}</p>
                        </article>
                        {/* <article className="col-span-2 md:col-span-1 p-3 rounded-lg border flex flex-col gap-1 justify-center items-center">
                            <PlusCircle />
                            <p className="text-sm text-center">Agregar al calendario</p>
                        </article> */}
                    </section>
                    <GoogleMapEmbed address={reservation.branchAddress} />
                    <section className="grid gap-3">
                        {
                            reservation?.branchPhone && (
                                <article className="rounded-lg px-4 py-3 border flex items-center justify-between">
                                    <a href={`tel:${reservation?.branchPhone}`} className="block">
                                        <h3 className="font-semibold">Número de teléfono</h3>
                                        <p className="font-normal text-sm">{reservation?.branchPhone}</p>
                                    </a>
                                    <Phone />
                                </article>
                            )
                        }
                        <button onClick={download} type="button" className="rounded-lg px-4 py-5 border flex items-center justify-between">
                            <h3 className="font-semibold">Descargar confirmación</h3>
                            <Download />
                        </button>
                    </section>
                </main>
            </div>
            {/* <footer className="w-full bg-[#E3E3E3] flex items-center justify-center py-2.5">
                <p className="text-sm">Powered by <span className="font-semibold">Popadvise</span></p>
            </footer> */}
        </>
    )
}

const GoogleMapEmbed = ({ address }) => {
    return (
        <div className="rounded-xl overflow-hidden mb-8 border shadow-md">
            <iframe
                width="100%"
                height="132"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${process.env.NEXT_PUBLIC_GOOGLEMAPS_KEY}&q=${encodeURIComponent(address.address)}`}
            />
        </div>

    );
};